import { NodeModel } from "@minoru/react-dnd-treeview";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ConfigurationPage } from "../components/ConfigurationPage";
import { ShelfSearchInput } from "./components/ShelfSearchInput";
import { ShelvesTree } from "./components/ShelvesTree";
import { useShelvesContext } from "./context/ShelvesContext";
import { useSearchShelves } from "./hooks/useSearchShelves";
import { ShelfSearchResult } from "./hooks/useShelfSearch";
import { FileProperties } from "./models/FileProperties";

type Props = {};

export const ConfigurationShelvesPage = (prop: Props) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [selectedNodes, setSelectedNodes] = useState<
		NodeModel<FileProperties>[]
	>([]);

	const {
		state: { shelvesNodes, openShelves },
		actions: { setOpenShelves },
	} = useShelvesContext();
	const searchShelves = useSearchShelves({ setIsLoading, setError });

	const handleSearchResultClick = (result: ShelfSearchResult) => {
		const expandPath = (nodeId: number): number[] => {
			const path: number[] = [];
			const findNodeAndPath = (currentId: number): void => {
				const node = shelvesNodes.find((n) => n.id === currentId);
				if (node && node.parent !== -1) {
					path.unshift(currentId);
					findNodeAndPath(node.parent as number);
				} else if (node) {
					path.unshift(currentId);
				}
			};
			findNodeAndPath(nodeId);
			return path;
		};

		const pathToExpand = expandPath(result.id);

		const newOpenShelves = { ...openShelves };
		pathToExpand.forEach((nodeId) => {
			newOpenShelves[nodeId] = nodeId;
		});

		setOpenShelves(newOpenShelves);

		setSelectedNodes([result.node]);
		setTimeout(() => {
			const nodeElement = document.querySelector(
				`[data-node-id="${result.id}"]`,
			);
			if (nodeElement) {
				nodeElement.scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
			}
		}, 300);
	};

	useEffect(() => {
		searchShelves();
	}, []);

	return (
		<ConfigurationPage
			title="Shelves"
			filters={
				<ShelfSearchInput
					shelvesNodes={shelvesNodes}
					onSearchResultClick={handleSearchResultClick}
				/>
			}
		>
			<Paper
				elevation={1}
				sx={{
					width: "100%",
					py: 1,
					px: 2,
					borderRadius: "0.75rem",
				}}
			>
				<DndProvider backend={HTML5Backend}>
					<ShelvesTree
						isLoading={isLoading}
						searchShelves={searchShelves}
						error={error}
						setError={setError}
						selectedNodes={selectedNodes}
						setSelectedNodes={setSelectedNodes}
					/>
				</DndProvider>
			</Paper>
		</ConfigurationPage>
	);
};
